import React from 'react';
import cx from 'classnames';

import './styles';
import { useTranslation } from 'react-i18next';

const LandingPageCTAButton = ({
  text = '',
  link = '',
  disabled,
  target,
  onClick = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('landing-page-button', { disable: disabled })}>
      <a href={link} target={target} onClick={onClick}>
        {t(text)}
      </a>
    </div>
  );
};

export default LandingPageCTAButton;
